var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleHWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "1339.948 493.36 270.035 270.035",
    width: "270.035pt",
    height: "270.035pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 1339.948 628.378 C 1339.948 553.86 1400.447 493.36 1474.965 493.36 C 1549.483 493.36 1609.983 553.86 1609.983 628.378 C 1609.983 702.896 1549.483 763.395 1474.965 763.395 C 1400.447 763.395 1339.948 702.896 1339.948 628.378 Z ",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1442.238 710.196 L 1453.147 710.196 C 1455.154 710.196 1456.783 711.825 1456.783 713.832 L 1456.783 724.742 C 1456.783 726.748 1455.154 728.378 1453.147 728.378 L 1442.238 728.378 C 1440.231 728.378 1438.601 726.748 1438.601 724.742 L 1438.601 713.832 C 1438.601 711.825 1440.231 710.196 1442.238 710.196 Z",
    style: {
      stroke: "none",
      fill: "#FF5757",
      strokeMiterlimit: 10
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 1456.783 532.014 C 1456.783 530.007 1455.154 528.378 1453.147 528.378 L 1442.238 528.378 C 1440.231 528.378 1438.601 530.007 1438.601 532.014 L 1438.601 688.378 C 1438.601 690.385 1440.231 692.014 1442.238 692.014 L 1453.147 692.014 C 1455.154 692.014 1456.783 690.385 1456.783 688.378",
    fill: "rgb(0,0,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 1456.783 619.287 C 1456.783 609.342 1472.009 610.196 1474.965 610.196 C 1477.921 610.196 1493.147 610.505 1493.147 619.287 Q 1493.147 628.069 1493.147 724.742 C 1493.147 726.748 1494.776 728.378 1496.783 728.378 L 1507.692 728.378 C 1509.699 728.378 1511.329 726.748 1511.329 724.742 Q 1511.329 614.761 1511.329 605.821 C 1511.329 596.881 1483.735 592.014 1474.965 592.014 Q 1447.692 591.978 1447.692 601.105",
    fill: "rgb(0,0,0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHWhite);
export default __webpack_public_path__ + "static/media/circle-h-white.70fc3ce37bfb4bd9f82ce7a15fe5ba2a.svg";
export { ForwardRef as ReactComponent };